import { computed, Injectable, signal } from '@angular/core';

import {
  AircraftDTO,
  AircraftModelDTO,
  AttachmentsDTO,
  ContractDTO,
  CountryDTO,
  EngineDTO,
  EnrollmentScenarioType,
  OperationType,
} from '../models/esp-enrollment.model';

@Injectable({
  providedIn: 'root',
})
export class SharedDataService {
  enrollmentScenario = signal<EnrollmentScenarioType>('New enrollment');
  sellersEspAgreementNo = signal<string | null>(null);
  contract = signal<ContractDTO | null | undefined>(null);
  recipientName = signal<string | null | undefined>(null);
  recipientLastName = signal<string | null | undefined>(null);
  badgeNumber = signal<string | null | undefined>(null);
  customerCode = signal<string | null | undefined>(null);
  customerEmail = signal<string | null | undefined>(null);
  customerCompanyName = signal<string | null | undefined>(null);
  aircraftDetails = signal<AircraftDTO | null>(null);
  requestReferenceNumber = signal('');
  requestInstanceNumber = signal('');
  enginesForAircraft = signal<EngineDTO[] | []>([]);
  selectedEngines = signal<EngineDTO[] | []>([]);
  isEngineManualEntry = signal(false);
  numberOfEngines = signal(0);
  engineAttachment = signal<AttachmentsDTO[] | null>(null);
  contactAttachment = signal<AttachmentsDTO[] | null>(null);
  token = signal<string | null>(null);
  coverageLevels = signal<string[]>([]);
  isAircraftReady = signal(false);
  managementCompanyContactNotPresent = signal<boolean>(false);
  interestHolderContactNotPresent = signal<boolean>(false);
  countries = signal<CountryDTO[]>([]);
  operationTypes = signal<OperationType[]>([]);
  aircraftModels = signal<AircraftModelDTO[]>([]);

  recipientFullName = computed(
    () => `${this.recipientName()} ${this.recipientLastName()}`,
  );

  setUserDetails(
    badgeNumber: string | null | undefined,
    customerCode: string | null | undefined,
    customerEmail: string | null | undefined,
    firstName: string | null | undefined,
    lastName: string | null | undefined,
  ) {
    this.recipientName.set(firstName);
    this.recipientLastName.set(lastName);
    this.badgeNumber.set(badgeNumber);
    this.customerCode.set(customerCode);
    this.customerEmail.set(customerEmail);
  }

  clearFormData() {
    this.aircraftDetails.set(null);
    this.requestReferenceNumber.set('');
    this.requestInstanceNumber.set('');
    this.enginesForAircraft.set([]);
    this.selectedEngines.set([]);
    this.isEngineManualEntry.set(false);
    this.numberOfEngines.set(0);
    this.engineAttachment.set(null);
    this.isAircraftReady.set(false);
  }
}
